import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { EstimateBalanceWorkflowStatus } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { BalanceStatusChipComponent } from '../../../review-multi-visit/components/balance-status-chip/balance-status-chip.component'

@Component({
  selector: 'mmx-modify-session-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, BalanceStatusChipComponent],
  templateUrl: './modify-session-header.component.html',
  styleUrls: ['./modify-session-header.component.scss'],
})
export class ModifySessionHeaderComponent {
  @Input() status: EstimateBalanceWorkflowStatus | null = null
  @Input() isModifying = false
}
